import { tv, type VariantProps } from 'tailwind-variants';
export type OrMiniCtaBlockVariants = VariantProps<typeof orMiniCtaBlockC>;

const orMiniCtaBlockC = tv({
  slots: {
    base: '',
    contents:
      'container w-full rounded-30 py-12 lg:!px-10.5 lg:py-62 flex flex-col items-center lg:flex-row lg:justify-around gap-6 lg:gap-10',
    descriptionContainer: '[&>*]:paragraph-lg text-center lg:text-left',
    title: 'text-center lg:text-left',
  },
  variants: {
    topSpacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottomSpacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
    hasDescription: {
      true: {
        title: 'lg:text-balance',
      },
      false: {
        title: 'w-full',
      },
    },
    theme: {
      light: {
        contents: '!bg-skin-secondary',
        descriptionContainer: 'text-skin-primary',
      },
      dark: {
        contents: '',
        descriptionContainer: 'text-skin-tertiary',
      },
    },
  },
  compoundVariants: [],
});

export default orMiniCtaBlockC;
